import React, { useEffect, useState } from "react";
import Select from "react-select";

import { ResponsiveBar } from '@nivo/bar'
import { linearGradientDef } from '@nivo/core'


import "react-awesome-lightbox/build/style.css";
import { Modal, Col } from "react-bootstrap";
import { line } from "d3-shape";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css";
import "react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css";
import "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css";
import moment from "moment"
/* Styles */
import 'react-multi-carousel/lib/styles.css';
import "../../../../../../styles/app/pages/CampaingPreview.scss";
import "./fix.css"
const LineLayer = ({ bars, xScale, yScale }) => {
    const lineGenerator = line()
      .x(d => xScale(d.data.index) + d.width / 2)
      .y(d => yScale(d.data.data.lineValue));
  
    return (
      <path d={lineGenerator(bars)} fill="none" stroke="rgba(200, 30, 15, 1)" />
    );
  };
export function ExecutiveSummaryBar({ raw, total, mainTask, campaign, item: key, length }) {



    const [show, setShow] = useState(false);
    const _raw_base = [...raw].filter(row => row.task === mainTask);
    const data = []
    const pos_options = [...new Set(_raw_base.map(row => row.pos))]
    pos_options.forEach((pos) => {
        const results = _raw_base.filter((row) => row.pos === pos)
        const total = results.reduce((tl, row) => tl + Number(row.quantity), 0)

        const document = {
            pos: pos,
            quantity: total

        }
        data.push(document)

    })
    const col = length === key ? total % 2 !== 0 ? "col-12 p-2" : "col-6 p-2" : "col-6 p-2"
    return (
        <>
            <DetailsModal
                campaign={campaign}
                show={show}
                mainTask={mainTask}
                setShow={setShow}
                raw={_raw_base}
                onHide={() => setShow(false)}
                data={data}
            />
            <div className={col}>
                <div className="card text-center shadow-sm pointer-hover" style={{ height: "200px" }} onClick={() => setShow(true)}>
                    <br />
                    <h4 className="px-4 pt-4"><strong>{mainTask}</strong></h4>
                    <h6> Inventario por PDV</h6>

                    <div className="pb-4" style={{ height: "100px", width: "100%" }}>


                        <ResponsiveBar
                            data={data}
                            keys={['quantity']}
                            indexBy="pos"
                            minValue={1}
                            margin={{ top: 0, right: 10, bottom: -60, left: 10 }}
                            valueScale={{ type: 'linear' }}
                            indexScale={{ type: 'band', round: true }}
                            colors={{ scheme: 'purpleRed_green' }}
                            borderColor={{ from: 'color', modifiers: [['darker', 1.6]] }}
                            axisTop={null}
                            axisRight={null}
                            defs={[linearGradientDef('gradientA', [
                                { offset: 0, color: '#AE46F2' },
                                { offset: 100, color: '#44116E' },


                            ])]}
                            fill={[{ match: { id: 'quantity' }, id: 'gradientA' }]}
                            axisBottom={{
                                tickSize: 5,
                                tickPadding: 1,
                                tickRotation: 0,
                                legend: '',
                                legendPosition: 'middle',
                                legendOffset: 32
                            }}
                            axisLeft={{
                                tickSize: 5,
                                tickPadding: 5,
                                tickRotation: 0,
                                legend: '',
                                legendPosition: 'middle',
                                legendOffset: -40
                            }}
                            enableGridX={false}
                            enableGridY={false}
                            enableLabel={false}
                            labelSkipWidth={12}
                            labelSkipHeight={12}
                            labelTextColor={{ from: 'color', modifiers: [['darker', 1.6]] }}
                            animate={true}
                            motionStiffness={90}
                            motionDamping={15}
                        />
                    </div>

                </div>



            </div>


        </>
    );
}
export function DetailsModal({
    raw,
    show,
    onHide,
    mainTask,
    setShow,

}) {
    // const data_by_product = []


    const [data, setData] = useState([])
    const [pos, setPOS] = useState(null)
    const [product, setProduct] = useState(null)
    const def = { label: "NONE", value: null }
    const pos_options = [...new Set(raw.map(row => row.pos))]
    const product_options = [...new Set(raw.map(row => row.product))]

    const [keys, setKeys] = useState(product_options)



    const select_pos = [def, ...pos_options.map(key => ({ label: key, value: key }))]
    const select_prd = [def, ...product_options.map(key => ({ label: key, value: key }))]

    useEffect(() => {
        const data_by_pos = []
        const postolist = pos_options.filter((_pos) => _pos === pos?.value)
        postolist.forEach((_pos) => {
            const results = raw.filter((row) => row.pos === _pos).filter((row) => row.product === product?.value || !product?.value)
            const _dates = [...new Set(raw.map(row => row.write))].sort((a, b) => moment(a, "MM/DD/YYYY").toDate() - moment(b, "MM/DD/YYYY").toDate())
            _dates.forEach(date => {
                const by_date = results.filter(row => row.write === date)
                console.log(by_date)
                const pos = by_date.reduce((hash, row) => {
                    hash[row.product] = hash[row.product] ?? 0;
                    hash[row.product] += Number(row.quantity)
                    return hash;
                }, {});
                const total = by_date.reduce((tl, row) => tl + Number(row.quantity), 0)
                const document = {
                    date: date,
                    quantity: total,
                    ...pos,
                }
                data_by_pos.push(document)

            })

        })
        setData(data_by_pos)
    }, [pos, product])

    console.log(data)

    return (
        <Modal show={show}
            size="lg"
            closeButton
            dialogClassName="modal-90w"
        >
            <Modal.Header onHide={onHide} closeButton>
                <div className="row d-flex w-100 justify-content-between">
                    <div className="col-10">
                        <h1>Detalle, {mainTask}</h1>
                    </div>
                    <div className="col">
                        <div className="d-flex w-100 justify-content-end">
                            <span className="d-inline pointer-hover" onClick={() => {
                                setShow(false)
                            }}>
                                <i class="fas fa-times fa-2x" style={{ color: "#000" }}></i>
                            </span>
                        </div>
                    </div>
                </div>
            </Modal.Header>

            <Modal.Body>
                <div className="row p-2">
                    <Col xs={12}><h5>*Debes seleccionar algun filtro para poder ver los datos.</h5></Col>
                    <Col xs={3}>
                        <label>Select POS</label>
                        <Select
                            value={pos}
                            defaultValue={def}
                            options={select_pos}
                            onChange={(args) => {
                                setPOS(args)
                            }}
                        />
                    </Col>
                    <Col xs={3}>
                        <label>Select Product</label>
                        <Select
                            value={product}
                            options={select_prd}
                            onChange={(args) => {
                                setProduct(args)
                            }} />
                    </Col>
                    <Col xs={3}>
                        <br />

                        <button
                            className="btn btn-secondary mt-2"
                            onClick={() => {
                                setPOS(null)
                                setProduct(null)
                                setKeys(product_options)

                            }} >
                            Reset
                        </button>
                    </Col>
                </div>


                <div className="pb-4" style={{ height: "600px", width: "100%" }}>

                    <ResponsiveBar
                        data={data}
                        keys={keys}
                        indexBy={"date"}
                        margin={{ top: 20, right: 90, bottom: 50, left: 90 }}
                        padding={0.3}
                        valueScale={{ type: 'linear' }}
                        indexScale={{ type: 'band', round: true }}
                        colors={{ scheme: 'spectral' }}

                        borderColor={{ from: 'color', modifiers: [['darker', 1.6]] }}
                        axisTop={null}
                        axisRight={null}
                        axisBottom={{
                            tickSize: 3,
                            tickPadding: 5,
                            // tickRotation: -45,
                            legend: '',
                            legendPosition: 'middle',
                            legendOffset: 32
                        }}
                        axisLeft={{
                            tickSize: 5,
                            tickPadding: 5,
                            tickRotation: 0,
                            legend: 'quanity',
                            legendPosition: 'middle',
                            legendOffset: -40
                        }}
                        labelSkipWidth={12}
                        labelSkipHeight={12}
                        labelTextColor={{ from: 'color', modifiers: [['darker', 1.6]] }}
                        layers={['grid', 'axes', 'bars', 'markers', 'legends', 'annotations', LineLayer]}
                        animate={true}
                        motionStiffness={90}
                        motionDamping={15}
                    />
                </div>

            </Modal.Body>

        </Modal>
    )
}

